import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Form } from "react-bootstrap";
import "./GCV_Form.css";

function GCV_Form({ onNext, onCancel }) {
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        {/* Measurement Period */}
        <div className="row mb-3">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Measurement Period</Form.Label>
              <Form.Control placeholder="Measurement Period" />
            </Form.Group>
          </div>
        </div>

        {/* TABLE DESIGN (Same Pattern as Listing Table) */}
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table customer_table measurement_input_table">
              <thead>
                <tr>
                  <th>Observation Value</th>
                  <th>Standard Deviation</th>
                  <th>Standard Uncertainity</th>
                  <th>Reported Uncertainty </th>
                  <th>Combined Uncertainity</th>
                  <th>Attach File</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <Form.Control placeholder="Value" />
                  </td>
                  <td>
                    <Form.Control placeholder="Value" />
                  </td>
                  <td>
                    <Form.Control placeholder="Value" />
                  </td>
                  <td>
                    <Form.Control placeholder="Value" />
                  </td>
                  <td>
                    <Form.Control placeholder="Value" />
                  </td>
                  <td className="text-center">
                    <span className="upload_link red_text">
                      <FontAwesomeIcon icon={faUpload} /> Upload File
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Buttons */}
        <div className="permission_btn_holder mt-4">
          <Button className="permission_btn No_btn" onClick={onCancel}>
            Reset
          </Button>
          <Button className="permission_btn Yes_btn" onClick={onNext}>
            Save & Next
          </Button>
        </div>
      </div>
    </section>
  );
}

export default GCV_Form;
